<template>
  <div>
    <div class = "box" v-if="isAgentModel">
      <img v-show="dataList.IsShowWithdrawModule" src="http://xsoss2016.oss-cn-hangzhou.aliyuncs.com/melyshop/image/personalwithdrawal20240222.png">
      <img v-show="!dataList.IsShowWithdrawModule" style="height:100%;width:100%" src="http://xsoss2016.oss-cn-hangzhou.aliyuncs.com/melyshop/image/personalwithdrawal20240222-2.png">
    </div>
    <div class = "box" v-else style="height: 280px;">
      <img v-show="dataList.IsShowWithdrawModule" src="https://cdn.dkycn.cn/images/melyshop/2025081110110002.png?v=1">
      <img v-show="!dataList.IsShowWithdrawModule" style="height:100%;width:100%" src="https://cdn.dkycn.cn/images/melyshop/2025081110110003.png?v=1">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataList: {
      type: Object
    }
  },
  data() {
			return {
				isAgentModel: false
			};
		},
  created(){
    this.isAgentModel = window.localStorage.getItem('mlmzDistributionModel') == 1
  }
}
</script>

<style lang = "less" scoped>
  .box{
    background: white;
    /* padding: 20px; */
    padding: 0px;
    margin: 0px;
    vertical-align:bottom;
    height: 108px;
    img{
      width:100%
    }
  }
</style>